import { setHideAppBanner } from './setHideAppBanner';
export function changePage() {
  setHideAppBanner();
}